import { AppBar, Box, Tab, Tabs } from "@material-ui/core"
import PropTypes from "prop-types"
import React, { useState } from "react"
import "../App.css"
import AdminCreationKey from "./AdminCreationKey"
import Blacklist from "./Blacklist"
import CarPriorityTimes from "./CarPriorityTimes"
import OrderPriorityTime from "./OrderPriorityTime"
import ContactPhoneNumber from "./ContactPhoneNumber"
import DefaultForwardMessage from "./DefaultForwardMessage"
import DefaultRejectReason from "./DefaultRejectReason"
import DiscountRates from "./DiscountRates"
import ExpirationTime from "./ExpirationTime"
import IdleOrderForward from "./IdleOrderForward"
import MaxPassengerCount from "./MaxPassengerCount"
import AppMinVersions from "./AppMinVersions"
import OrderLimit from "./OrderLimit"
import TimedOrderLimit from "./TimedOrderLimit"
import Whitelist from "./Whitelist"
import WorkShiftTime from "./WorkShiftTime"
import UserManagement from "./UserManagement"
import {ReservationManagement} from "./ReservationManagement"

function TabPanel(props) {
	const { children, value, index, ...other } = props
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}>
			{value === index && <Box p={3}>{children}</Box>}
		</div>
	)
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
}

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	}
}

const tabData = [
	{ label: "Aikaraja", components: [TimedOrderLimit] },
	{ label: "Hetitilaukset", components: [OrderLimit] },
	{ label: "Estetyt/Luotetut", components: [Whitelist, Blacklist] },
	{ label: "Alennukset", components: [DiscountRates] },
	{ label: "Välitysaika", components: [IdleOrderForward] },
	{ label: "Vuorot", components: [WorkShiftTime] },
	{ label: "Priorisointi", components: [CarPriorityTimes, OrderPriorityTime] },
	{ label: "Viestit", components: [DefaultRejectReason, DefaultForwardMessage] },
	{ label: "Tietokanta", components: [ExpirationTime] },
	{ label: "Admin-avain", components: [AdminCreationKey] },
	{ label: "Yhteydenottopuhelinnumero", components: [ContactPhoneNumber] },
	{ label: "Maksimi matkustajamäärä", components: [MaxPassengerCount]},
	{ label: "Sovelluksen vähimmäisversiot", components: [AppMinVersions] },
	{ label: "Käyttäjähallinta", components: [UserManagement] },
	{ label: "Vuorojen varaus", components: [ReservationManagement]}
]

function Configurations(props) {
	const [value, setValue] = useState(0)

	const handleChange = (event, newValue) => {
		setValue(newValue)
	}

	return (
		<>
			<AppBar position="relative">
				<Box>
					<Tabs value={value} onChange={handleChange} sx={{ minWidth: "100%" }}>
						{tabData.map((tab, index) => (
							<Tab key={index} label={tab.label} {...a11yProps(index)} />
						))}
					</Tabs>
				</Box>
			</AppBar>
			{tabData.map((tab, index) => (
				<TabPanel key={index} value={value} index={index}>
					{tab.components.map((Component, idx) => (
						<Component
							key={idx}
							dispatch={props.dispatch}
							stopListRefresh={props.stopListRefresh}
							carPriorityList={props.carPriorityTimes}
							{...props}
						/>
					))}
				</TabPanel>
			))}
		</>
	)
}

export default Configurations
